export const roles: Record<string, string> = {
  admin: 'Admin',
  // user: 'User',
  patroller: 'Patroller',
  'summary-recipient': 'Summary Recipient',
  watcher: 'Watcher',
};
